import { Data_getInstance2cqf333fbh84a as Data_getInstance } from './adapter/SavePairAssignmentsMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SavePairAssignmentsMutationSelections_getInstance2o9cmckwdmemc as SavePairAssignmentsMutationSelections_getInstance } from './selections/SavePairAssignmentsMutationSelections.mjs';
import { SavePairAssignmentsMutation_VariablesAdapter_instance19cw5hj1ibnpf as SavePairAssignmentsMutation_VariablesAdapter_instance } from './adapter/SavePairAssignmentsMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(savePairAssignments) {
        this.savePairAssignments_1 = savePairAssignments;
      }
      toString() {
        return 'Data(savePairAssignments=' + this.savePairAssignments_1 + ')';
      }
      hashCode() {
        return this.savePairAssignments_1 == null ? 0 : getBooleanHashCode(this.savePairAssignments_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.savePairAssignments_1 == other.savePairAssignments_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.ADAPTER_1 = obj(Data_getInstance());
        this.ROOT_FIELD_1 = (new (Builder())('data', Companion_getInstance().type_1)).selections_gjxob8_k$(SavePairAssignmentsMutationSelections_getInstance().__root_1).build_1k0s4u_k$();
        this.OPERATION_ID_1 = 'b177b922ea7e084a060efcefb01d21964d1902cda25617294c2e1bcfe587b840';
        this.OPERATION_NAME_1 = 'savePairAssignments';
      }
      get_OPERATION_DOCUMENT_t250nw_k$() {
        return 'mutation savePairAssignments($input: SavePairAssignmentsInput!) { savePairAssignments(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SavePairAssignmentsMutationClass;
function SavePairAssignmentsMutation() {
  if (SavePairAssignmentsMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.input_1 = input;
      }
      operationId_2580de_k$() {
        return 'b177b922ea7e084a060efcefb01d21964d1902cda25617294c2e1bcfe587b840';
      }
      operationId() {
        return this.operationId_2580de_k$();
      }
      document_e91o2j_k$() {
        return Companion_getInstance_0().get_OPERATION_DOCUMENT_t250nw_k$();
      }
      operationName_1injiq_k$() {
        return 'savePairAssignments';
      }
      operationName() {
        return this.operationName_1injiq_k$();
      }
      serializeVariables_bugef7_k$(writer, customScalarAdapters, withDefaultValues) {
        SavePairAssignmentsMutation_VariablesAdapter_instance.serializeVariables_vodk28_k$(writer, this, customScalarAdapters, withDefaultValues);
      }
      adapter_j0zdtd_k$() {
        return Companion_getInstance_0().ADAPTER_1;
      }
      toString() {
        return 'SavePairAssignmentsMutation(input=' + this.input_1.toString() + ')';
      }
      hashCode() {
        return this.input_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsMutation()))
          return false;
        if (!this.input_1.equals(other.input_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsMutation', VOID, VOID, [Mutation()]);
    SavePairAssignmentsMutationClass = $;
  }
  return SavePairAssignmentsMutationClass;
}
//region block: exports
export {
  Data as Data2n9h8mazd823k,
  SavePairAssignmentsMutation as SavePairAssignmentsMutation1xoyawurksq0m,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsMutation.mjs.map
